import api from '@/soluqr/api/solugoApi';

/**
 * GET /api/solugo/public/coverage/check — validación de cobertura operativa SoluGo.
 * @returns {Promise<{ inCoverage: boolean, reason: string, degraded?: boolean, unavailable?: boolean }>}
 */
export async function checkSoluGoPublicCoverage({ commune, lat, lng, address, signal } = {}) {
  const params = new URLSearchParams();
  if (commune) params.set('commune', String(commune).trim());
  if (typeof lat === 'number' && Number.isFinite(lat)) params.set('lat', String(lat));
  if (typeof lng === 'number' && Number.isFinite(lng)) params.set('lng', String(lng));
  if (address) params.set('address', String(address).trim());

  const qs = params.toString();
  try {
    const { data } = await api.get(
      `/solugo/public/coverage/check${qs ? `?${qs}` : ''}`,
      signal ? { signal } : undefined,
    );

    return {
      inCoverage: Boolean(data?.in_coverage),
      reason: typeof data?.reason === 'string' ? data.reason.trim() : '',
      degraded: Boolean(data?.degraded),
      unavailable: false,
    };
  } catch {
    return {
      inCoverage: false,
      reason: 'No se pudo verificar cobertura SoluGo en este momento.',
      unavailable: true,
    };
  }
}
